import React from 'react'
// import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, InlineLoader} from '@modifi/ui'

const propTypes = {}
const defaultProps = {}

type PageLoaderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const PageLoader: React.FC<PageLoaderProps> = () => (
  <Row justifyContent="center">
    <Col auto>
      <InlineLoader />
    </Col>
  </Row>
)

PageLoader.propTypes = propTypes
PageLoader.defaultProps = defaultProps

export default PageLoader
